// extracted by mini-css-extract-plugin
module.exports = {"container":"_0fce717cdb--container--iQTDK","iframe":"_0fce717cdb--iframe--TKEQK","close":"_0fce717cdb--close--T_Hie","spinner":"_0fce717cdb--spinner--mbuzw"};